import React, { useEffect } from "react";
import { TriggeredHook } from "sonobello.utilities.react";

import { Token } from "../../../../Models/Authentication";
import ISsoAuthorizationFormProps from "../../Types/ISsoAuthorizationForm";
import { IReauthenticatorFormProps } from "../Reauthenticator";

export interface ISsoReauthenticationForm extends IReauthenticatorFormProps {
  /** A react hook which obtains the oAuth identity for the user. */
  useGetOAuthIdentity: TriggeredHook<Token, undefined, string>;
  /** A form which prompts the user to initialize the oAuth process. */
  AuthForm: React.FC<ISsoAuthorizationFormProps>;
}

/** A wrapper which binds the SSO authentication form with the hook which obtains the token. */
const SsoReauthenticationForm: React.FC<ISsoReauthenticationForm> = ({ useGetOAuthIdentity, onChange, AuthForm }) => {
  const { error, result, execute, ...rest } = useGetOAuthIdentity();

  useEffect(() => {
    if (result) onChange(result);
  }, [result]);

  return AuthForm({ onClick: execute, label: null, errorMessage: error, ...rest });
};

export default SsoReauthenticationForm;
